var exports = {
  "k": "x234b8571--37aba3--container",
};

module.exports = exports;
